<template>
  <div>
    <el-row class="bottom20">
      <el-table :data="page.records" :row-class-name="getVisitedRowClassName" :cell-class-name="getSelectedCellClassName">
        <el-table-column prop="code">
          <template slot="header" slot-scope="scope">
            报告编号<br>
            <el-input size="mini" v-model="pageSearch.search.like_code" placeholder="报告编号"></el-input>
          </template>
          <template slot-scope="scope">
            <a href="javascript: void(0);" @click.self="look(scope.row)">{{scope.row.code}}</a>
          </template>
        </el-table-column>

        <el-table-column prop="roomId">
          <template slot="header" slot-scope="scope">
            数据中心<br>
            <dictionary-select v-model="pageSearch.search.eq_roomId" @loaded="roomLoaded" :factory-name="'room'" :params="{type: 'AUTH_SITE'}" clearable filterable size="mini"></dictionary-select>
          </template>
          <template slot-scope="scope">
            <dictionary-text :factory-name="'room'" :params="{type: 'AUTH_SITE'}" :value="scope.row.roomId"></dictionary-text>
          </template>
        </el-table-column>

        <el-table-column prop="name">
          <template slot="header" slot-scope="scope">
            报告名称<br>
            <el-input size="mini" v-model="pageSearch.search.like_name" placeholder="请输入报告名称"></el-input>
          </template>
          <template slot-scope="scope">
            {{scope.row.name}}
          </template>
        </el-table-column>

        <el-table-column prop="failureLevel">
          <template slot="header" slot-scope="scope">
            故障等级<br>
            <dictionary-select v-model="pageSearch.search.in_failureLevel" :factory-name="'domain'" :params="'RPLEVEL'" clearable multiple collapseTags size="mini"></dictionary-select>
          </template>
          <template slot-scope="scope">
            <dictionary-text :factory-name="'domain'" :params="'RPLEVEL'" :value="scope.row.failureLevel"></dictionary-text>
          </template>
        </el-table-column>

        <el-table-column prop="failureStartTime">
          <template slot="header" slot-scope="scope">
            故障开始时间<br>
            <div style="height: 40px;"></div>
          </template>
          <template slot-scope="scope">
            {{scope.row.failureStartTime}}
          </template>
        </el-table-column>

        <el-table-column prop="reporterName">
          <template slot="header" slot-scope="scope">
            报告制作人<br>
            <el-input size="mini" v-model="pageSearch.search.like_reporterName" placeholder="请输入报告制作人"></el-input>
          </template>
          <template slot-scope="scope">
            {{scope.row.reporterName}}
          </template>
        </el-table-column>

        <el-table-column prop="status">
          <template slot="header" slot-scope="scope">
            状态<br>
            <dictionary-select v-model="pageSearch.search.in_status" :factory-name="'domain'" :params="'RPSTATUS'" clearable multiple collapseTags size="mini"></dictionary-select>
          </template>
          <template slot-scope="scope">
            <dictionary-text :factory-name="'domain'" :params="'RPSTATUS'" :value="scope.row.status"></dictionary-text>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row type="flex" class="row-bg" justify="end">
      <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page="pageSearch.current"
              :page-sizes="[10, 25, 50, 100]"
              :page-size="pageSearch.size"
              layout="total, sizes, prev, pager, next, jumper"
              :total="page.total">
      </el-pagination>
    </el-row>
  </div>
</template>

<script>
  import Emitter from 'element-ui/src/mixins/emitter'
  import { debounce } from "@/util/common"
  import DictionarySelect from '@/components/common/DictionarySelect'
  import DictionaryText from '@/components/common/DictionaryText'
  import {selected, visited, page} from  '@/mixins/table'
  import ReviewServer from  '@/api/review'

  // import { dictionaryContainer, Dictionary } from '@/util/common/dictionary'

  export default {
    name: "ReviewReportList",
    mixins: [Emitter, selected, visited, page],
    components: {
      DictionarySelect,
      DictionaryText,
    },
    props: {
      search: {},
    },
    data() {
      return {
        key: 'id',
        pageSearch: {
          search: {
            currentOrder: null,
            like_code: null,
            eq_roomId: null,
            in_roomId: [-1],
            like_name: null,
            eq_failureLevel: null,
            in_failureLevel: null,
            like_reporterName: null,
            eq_status: null,
            in_status: null,

            range_failureStartTime: null,
            eq_failureType: null,
            eq_type: null,
            in_id: null,
          }
        }
      };
    },
    computed: {
    },
    watch: {
      search: {
        deep: true,
        handler(value) {
          if (value != null) {
            let source = value;
            let target = this.pageSearch.search;
            for (let key in source) {
              if (source.hasOwnProperty(key) && source[key] !== target[key]) {
                target[key] = source[key];
              }
            }
          }
        }
      },
      'pageSearch.search': {
        deep: true,
        handler(value) {
          if (value != null) {
            this.dispatch('ReviewReportMain', 'search-change', value);
          }
        }
      }
    },
    methods: {
      roomLoaded(roomDictionary) {
        let inRoomIds;
        const roomIds = roomDictionary.getValues();
        if (roomIds == null || roomIds.length <= 0) {
          inRoomIds = [-1];
        } else {
          inRoomIds = roomIds;
        }
        this.pageSearch.search.in_roomId = inRoomIds;
      },
      look(data) {
        this.select(data);
        this.visit(data);
        this.$emit('show-detail', data);
      },
      queryByPage: debounce(function(pageSearch) {
        ReviewServer.reviewReport.page(pageSearch).then((res) => {
          if (res.data.code === 200) {
            this.page = {
              total: res.data.result.total,
              records: res.data.result.records,
            };
          }
        });
      }, 200),
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
